import React from 'react';

import { useLotMatrix } from '../hooks/useLotMatrix';
import { findCell } from '../utils/rates';
import { hasExclusion } from './ExclusionMatrix';
import { RateInput } from './RateInput';
import { RoleLevelMatrices } from './RoleLevelMatrices';
import { RoleLevelMatrix } from './RoleLevelMatrix';

export const RateInputMatrices = ({ resource, id, lotId, rates, exclusions, onSave }) => {
  const matrix = useLotMatrix(resource, id, lotId);

  return (
    <RoleLevelMatrices
      {...matrix}
      emptyText="Add roles to this lot before setting rates"
      renderMatrix={(group) => (
        <RoleLevelMatrix
          {...group}
          label={`Rates for ${group.structure.name}`}
          showDescriptions
          renderCell={(role, level) => (
            <RateInput
              label={`Rate ${role.name} ${level.name}`}
              value={findCell(rates, role.role_id, level.level_id)?.rate}
              excluded={hasExclusion(exclusions, role.role_id, level.level_id)}
              onSave={(rate) => onSave(role.role_id, level.level_id, rate)}
            />
          )}
        />
      )}
    />
  );
};
